<template>
  <div class="card-key">
    <div class="card-input-container">
      <van-cell-group>
        <van-field
          v-model="cardKey"
          label="卡密"
          placeholder="请输入卡密"
          :error="!!error"
          :error-message="error"
          @input="clearError"
        />
      </van-cell-group>
      <div class="tip-message">
        <van-icon name="info-o" />
        <span>卡密有效期只有为当天，请尽早下单</span>
      </div>
      <div class="button-container">
        <van-button
          type="primary"
          block
          @click="submitCardKey"
          :loading="loading"
        >
          确认
        </van-button>
      </div>
    </div>

    <!-- 订单列表弹窗 -->
    <van-popup v-model="showOrderList" position="bottom" round closeable :style="{ height: '70%' }">
      <div class="order-list-popup">
        <div class="popup-title">选择要查看的订单</div>
        <div class="order-list">
          <div
            v-for="order in recentOrders"
            :key="order.orderId"
            class="order-item"
            @click="goToOrderDetail(order.orderId)"
          >
            <div class="order-info">
              <div class="shop-name">
                <van-icon name="shop-o" />
                {{ order.mainOrderData?.shopData?.shopName || '未知店铺' }}
              </div>
              <div class="goods-info">
                <span class="goods-name">商品名:{{ getGoodsNames(order) }}</span>
                <span class="goods-count">共{{ getGoodsCount(order) }}件</span>
              </div>
              <div class="order-meta">
                <span class="order-time">{{ formatOrderTime(order.creator?.time) }}</span>
                <van-tag :type="getOrderStatusType(order.orderStatus)">
                  {{ getOrderStatusText(order.orderStatus) }}
                </van-tag>
              </div>
            </div>
            <van-icon name="arrow" />
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import request from "@/utils/request";
import { getConfig } from "@/constants/appConfig";

export default {
  name: "CardKey",
  data() {
    return {
      cardKey: "",
      error: "",
      loading: false,
      showOrderList: false,
      recentOrders: [],
    };
  },
  computed: {
    ...mapState(["qmUserToken", "appConfig"]),
  },
  created() {
    // 先清空缓存的qmUserToken和localStorage
    this.$store.dispatch("clearQmUserToken");
    this.$store.dispatch("clearMemberCoupon");
    this.$store.dispatch("clearUuid");
    this.$store.dispatch("clearOrderId");
    // localStorage.clear(); // 一般不需要清空所有localStorage

    // 如果已经有卡密，直接跳转到首页
    if (this.qmUserToken) {
      this.$router.push("/shop-list");
      return;
    }

    // 检查URL参数中是否有加密数据
    const encryptedData = this.$route.query.uuid;
    if (encryptedData) {
      this.cardKey = encryptedData;
      this.submitCardKey();
    }
  },
  methods: {
    ...mapActions(["setQmUserToken", "setMemberCoupon", "setUuid", "setOrderId", "clearOrderId"]),
    clearError() {
      this.error = "";
    },
    goToOrderDetail(orderId) {
      this.showOrderList = false;
      this.$router.push({
        path: "/order-detail",
        query: { orderId },
      });
    },
    getGoodsNames(order) {
      if (!order.productInfo || !order.productInfo.productList || order.productInfo.productList.length === 0) {
        return '无商品信息';
      }
      const productList = order.productInfo.productList;
      // 获取第一个商品名称
      const firstName = productList[0].productName;
      // 如果只有一个商品，直接返回
      if (productList.length === 1) {
        return firstName;
      }
      // 如果有多个商品，返回"商品名等N件"
      return `${firstName}等${productList.length}件`;
    },
    getGoodsCount(order) {
      if (!order.productInfo || !order.productInfo.productList) {
        return 0;
      }
      return order.productInfo.productList.reduce((total, product) => total + (product.quantity || 0), 0);
    },
    formatOrderTime(time) {
      if (!time) return '';
      // time 格式可能是时间戳或日期字符串，需要格式化
      return time.replace('T', ' ').substring(0, 19);
    },
    getOrderStatusText(status) {
      const statusMap = {
        'WAIT_PAY': '待支付',
        'ORDER_PLACED': '已下单',
        'MAKING': '制作中',
        'WAIT_PICK': '待取餐',
        'FINISH': '已完成',
        'COMPLETED': '已完成',
        'CANCEL': '已取消',
        'CANCELLED': '已取消',
        'REFUNDED': '已退款'
      };
      return statusMap[status] || status || '未知状态';
    },
    getOrderStatusType(status) {
      if (status === 'FINISH' || status === 'COMPLETED') {
        return 'success';
      } else if (status === 'CANCEL' || status === 'CANCELLED' || status === 'REFUNDED') {
        return 'danger';
      }
      return 'primary';
    },
    async submitCardKey() {
      if (!this.cardKey.trim()) {
        this.error = "请输入卡密";
        return;
      }
      this.loading = true;

      try {
        // 调用后端解密接口
        const response = await request.post("/encrypt/get-data", {
          uuid: this.cardKey.trim(),
        });
        console.log(response);
        

        if (!response) {
          throw new Error(response.message || "卡密验证失败");
        }

        const decryptedText = response.data.originalData;
        let qmUserToken = decryptedText.split("----")[1];
        await this.setQmUserToken(qmUserToken);

        console.log("qmUserToken 变量:",qmUserToken);
        console.log("store 中的 qmUserToken:", this.$store.state.qmUserToken);
        
        await this.setUuid(this.cardKey.trim());
        
        // 保存 orderId（用于提取手机号）
        const orderId = response.data.orderId;
        if (orderId) {
          await this.setOrderId(orderId);
          console.log("orderId 已保存:", orderId);
          console.log("提取的手机号:", this.$store.getters.phoneNumber);
        }
        
        let memberCouponId = decryptedText.split("----")[2];
        let teaType = decryptedText.split("----")[3];
        const defaultConfig = getConfig(teaType);
        defaultConfig.dataId = memberCouponId;
        this.$store.commit("SET_APP_CONFIG", defaultConfig);

        // 记录卡密是否已被使用
        const isCardUsed = response.data.isUsed === 1;

        // 调用订单列表接口
        try {
          const orderListResponse = await request.post("/gm/get-today-orders", {});

          console.log("订单列表返回：", orderListResponse);

          // 检查是否有符合条件的订单
          if (
            orderListResponse.data &&
            orderListResponse.data.orders &&
            orderListResponse.data.orders.data &&
            orderListResponse.data.orders.data.data &&
            orderListResponse.data.orders.data.data.length > 0
          ) {
            // 查找所有未取消且使用了相同优惠券的订单
            const matchedOrders = orderListResponse.data.orders.data.data.filter((order) => {
              const isNotCancelled = !["CANCEL", "CANCELLED", "WAIT_PAY"].includes(
                order.orderStatus
              );
              // 检查订单的商品优惠信息中是否包含相同的优惠券ID
              let isSameCouponId = false;
              if (order.productInfo && order.productInfo.productList) {
                isSameCouponId = order.productInfo.productList.some((product) => {
                  return product.promotionInfos && product.promotionInfos.some(
                    (promo) => promo.couponTemplateId === memberCouponId
                  );
                });
              }
              return isNotCancelled && isSameCouponId;
            });

            if (matchedOrders.length > 0 && isCardUsed) {
              // 只有在卡密已被使用的情况下，才显示订单列表
              this.recentOrders = matchedOrders.slice(0, 10);
              this.loading = false;
              
              // 询问用户是否查看订单
              this.$dialog.confirm({
                title: '提示',
                message: '该链接已被使用过，检测到您有历史订单。是否查看订单？',
                confirmButtonText: '查看订单',
                cancelButtonText: '取消',
              }).then(() => {
                // 用户点击确认，显示订单列表
                this.showOrderList = true;
              }).catch(() => {
                // 用户点击取消，不做任何操作
                console.log('用户取消查看订单');
              });
              
              return; // 显示订单列表，不继续执行后续代码
            }
            // 如果卡密未使用，即使有订单，也继续正常流程（不显示订单列表）
          }
        } catch (orderError) {
          console.error("获取订单列表失败：", orderError);
        }

        // 如果卡密已被使用，且没有找到订单（上面的 return 没有执行），则提示用户
        if (isCardUsed) {
          this.$toast.fail("该卡密已使用，请联系客服更换");
          this.loading = false;
          return;
        }

        let list = await request.post("/gm/get-coupons", {});

        console.log("list",list);
        
        // 新接口返回的数据结构：list.data.coupons.data.data
        // 使用 promotionId 进行匹配
        let memberCouponObj = null;
        if (list.data && list.data.coupons && list.data.coupons.data && list.data.coupons.data.data) {
          memberCouponObj = list.data.coupons.data.data.find(
            (item) => item.promotionId === memberCouponId
          );
        }

        console.log("memberCouponObj", memberCouponObj);
        

        if (!memberCouponObj) {
          this.$toast("该账号无对应免单卷，请联系客服售后处理");
          this.loading = false;
          return;
        }
        await this.setMemberCoupon(memberCouponObj);

        this.$router.push("/shop-list");
      } catch (error) {
        console.error("卡密验证失败:", error);
        this.error = error.message || "卡密验证失败";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.card-key {
  min-height: 100vh;
  background-color: #f7f8fa;
  display: flex;
  align-items: center;
  padding: 20px;
}

.card-input-container {
  width: 100%;
  background-color: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.button-container {
  margin-top: 20px;
}

.tip-message {
  margin-top: 12px;
  padding: 8px 12px;
  background-color: #f0f9ff;
  border-radius: 4px;
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #666;

  .van-icon {
    color: #1989fa;
    margin-right: 4px;
    font-size: 14px;
  }
}

.order-list-popup {
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #f7f8fa;

  .popup-title {
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    padding: 16px;
    background-color: #fff;
    border-bottom: 1px solid #f5f5f5;
  }

  .order-list {
    flex: 1;
    overflow-y: auto;
    padding: 12px;
  }

  .order-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 12px;
    cursor: pointer;
    transition: all 0.3s;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);

    &:active {
      background-color: #f5f5f5;
    }

    .order-info {
      flex: 1;

      .shop-name {
        font-size: 15px;
        font-weight: 600;
        color: #323233;
        margin-bottom: 10px;
        display: flex;
        align-items: center;

        .van-icon {
          color: #ee0a24;
          margin-right: 6px;
          font-size: 16px;
        }
      }

      .goods-info {
        display: flex;
        align-items: center;
        margin-bottom: 8px;

        .goods-name {
          font-size: 13px;
          color: #646566;
          flex: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .goods-count {
          font-size: 12px;
          color: #969799;
          margin-left: 8px;
        }
      }

      .order-meta {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .order-time {
          font-size: 12px;
          color: #969799;
        }
      }
    }

    > .van-icon {
      color: #969799;
      font-size: 16px;
      margin-left: 8px;
    }
  }
}
</style> 